var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Microphone_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microphone_",
    "data-name": "Microphone ",
    clipPath: "url(#clip-Microphone_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(-2591 -1823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    transform: "translate(2591 1823)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_627",
    "data-name": "Ellipse 627",
    cx: 24,
    cy: 24,
    r: 24,
    className: "icon-background"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-microphone",
    "data-name": "Icon awesome-microphone",
    d: "M9.45,18.9A5.154,5.154,0,0,0,14.6,13.745V5.155a5.155,5.155,0,1,0-10.309,0v8.591A5.154,5.154,0,0,0,9.45,18.9Zm8.591-8.591h-.859a.859.859,0,0,0-.859.859v2.577a6.881,6.881,0,0,1-7.559,6.839,7.081,7.081,0,0,1-6.186-7.145V11.168a.859.859,0,0,0-.859-.859H.859A.859.859,0,0,0,0,11.168v2.156A9.746,9.746,0,0,0,8.161,23.08v1.834H5.155a.859.859,0,0,0-.859.859v.859a.859.859,0,0,0,.859.859h8.591a.859.859,0,0,0,.859-.859v-.859a.859.859,0,0,0-.859-.859H10.739V23.1A9.459,9.459,0,0,0,18.9,13.745V11.168A.859.859,0,0,0,18.041,10.309Z",
    transform: "translate(14.53 9.744)",
    className: "icon-foreground"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.716a1c2df892e803d17708b026b4b7b4.svg";
export { ForwardRef as ReactComponent };